<form class="search-component">
    <div class="search-container">
        <input class="ihost-control" name="searchReservationTagsTerm" type="search" placeholder="{{ 'reservationTags.placeholders.search' | translate }}"
            [(ngModel)]="searchReservationTagsTerm">
        <button class="btn-clear" type="button" (click)="searchReservationTagsTerm = ''">&times;</button>
    </div>
    <!-- <a [canWrite]="'ManageTags'" class="btn btn-transparent btn-new" href="javascript:void(0);"
        (click)="showAddReservationTagModal()">{{'reservations.addNew' | translate}}</a> -->
</form>

<div class="main-container">
    <ng-container *ngFor="let tagCategory of tagCategories">
        <h3 *ngIf="displayCategoryLabel && tagCategory.tags != null && tagCategory.tags.length > 0" class="mt-4 mb-2">
            {{tagCategory.name}} -
            {{selectedTagsNumberByCategory(tagCategory)}}/{{tagCategory.tags.length}}</h3>
        <div *ngIf="tagCategory.tags != null && tagCategory.tags.length > 0" class="btn-tag-group"
            [class.mt-4]="!displayCategoryLabel">
            <label *ngFor="let tag of tagCategory.tags | filter:filterReservationTags:searchReservationTagsTerm"
                class="btn-tag" [style.backgroundColor]="tagCategory.color"
                [class.checked]="_selectedTags != null && hasReservationTag(tag)">
                <input [id]="'id' + tag.id" type="checkbox" [value]="tag.id"
                    [checked]="_selectedTags != null && hasReservationTag(tag)"
                    (change)="toggleSelectReservationTag(tag)">
                <span>{{tag.title}}</span>
            </label>
        </div>
    </ng-container>

    <ng-container *ngIf="displayAdditionalTextInput">
        <h3 [lang]="lang" class="mt-5 text-uppercase">{{'reservations.additionalDietaryRestrictions' |
            translate | uppercase }}</h3>
        <textarea class="ihost-control" placeholder="{{'reservations.typeAdditionalDietaryRestrictions' | translate}}"
            [ngModel]="additionalTextInput" (change)="setAdditionalText($event)">
        </textarea>
        <p class="text-faded text-sm mt-2"><i>* {{'reservations.dietaryRestrictionsMessage' |
                translate}}</i></p>
    </ng-container>
</div>

<!-- <a class="btn btn-xs btn-main mt-3" (click)="setReservationTags()">{{'reservations.done' | translate}}</a> -->

<!-- add new reservation tag modal -->
<app-reservation-tag-modal #reservationTagModal [modalId]="modalId" [categories]="tagCategories"
    [selectedTag]="reservationTag" [tagType]="tagType" (onClose)="reservationTagModalClosed($event)">
</app-reservation-tag-modal>